document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector('.use-with-ai-section');
  if (!section) return;

  const topTitle = section.querySelector('.use-with-ai__top h2');
  const topDesc = section.querySelector('.use-with-ai__top p');
  const cards = section.querySelectorAll('.use-with-ai-card');

  // Animate title
  if (topTitle) {
    gsap.fromTo(topTitle,
      { y: -20, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.6,
        ease: "power2.out",
        scrollTrigger: {
          trigger: topTitle,
          start: "top 80%",
          toggleActions: "play reverse play reverse"
        }
      }
    );
  }

  // Animate description
  if (topDesc) {
    gsap.fromTo(topDesc,
      { y: -10, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        delay: 0.1,
        duration: 0.5,
        ease: "power2.out",
        scrollTrigger: {
          trigger: topDesc,
          start: "top 80%",
          toggleActions: "play reverse play reverse"
        }
      }
    );
  }

  // Animate each card and its inner parts
  cards.forEach((card) => {
    const icon = card.querySelector('.use-with-ai-card__icon');
    const title = card.querySelector('.use-with-ai-card__title');
    const desc = card.querySelector('.use-with-ai-card__desc');
    const subtitle = card.querySelector('.use-with-ai-card__subtitle');
    const indicator = card.querySelector('.use-with-ai-card__indicator');

    // Card entrance
    gsap.fromTo(card,
      { y: 20, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.5,
        ease: "power2.out",
        scrollTrigger: {
          trigger: card,
          start: "top 85%",
          toggleActions: "play reverse play reverse"
        }
      }
    );

    if (icon) {
      gsap.fromTo(icon,
        { scale: 0.95, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          delay: 0.1,
          duration: 0.4,
          ease: "power2.out",
          scrollTrigger: {
            trigger: icon,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    if (title) {
      gsap.fromTo(title,
        { y: -15, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          delay: 0.15,
          duration: 0.5,
          ease: "power2.out",
          scrollTrigger: {
            trigger: title,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    if (desc) {
      gsap.fromTo(desc,
        { y: 10, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          delay: 0.2,
          duration: 0.5,
          ease: "power2.out",
          scrollTrigger: {
            trigger: desc,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    if (subtitle) {
      gsap.fromTo(subtitle,
        { y: -10, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          delay: 0.25,
          duration: 0.4,
          ease: "power2.out",
          scrollTrigger: {
            trigger: subtitle,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    if (indicator) {
      gsap.fromTo(indicator,
        { scale: 0.95, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          delay: 0.3,
          duration: 0.4,
          ease: "power2.out",
          scrollTrigger: {
            trigger: indicator,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  });
});
